import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=a5d1d170&"
import script from "./Presentation.vue?vue&type=script&lang=ts&"
export * from "./Presentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports